import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, NavigationError, Router, RouterOutlet } from '@angular/router';

import { Globals } from '@core/globals';
import { FormHeaderComponent } from '@layout/form-header/form-header.component';
import { PageMainComponent } from '@layout/page/page-main/page-main.component';
import { PageComponent } from '@layout/page/page.component';

@Component({
  selector: 'layout-form',
  imports: [RouterOutlet, FormHeaderComponent, PageComponent, PageMainComponent],
  templateUrl: './form.layout.html',
  styleUrls: ['./form.layout.scss'],
})
export class FormLayout {
  private router = inject(Router);
  private destroyRef = inject(DestroyRef);
  public globals = inject(Globals);
  public type: 'default' | 'car-valuation' = 'default';

  constructor() {
    this.router.events.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((routerEvent: any) => {
      if (routerEvent instanceof NavigationEnd || routerEvent instanceof NavigationError) {
        const firstSlashUrl = '/' + routerEvent.url.split('/')[1];
        this.type = firstSlashUrl === this.globals.routes()['carValuation'].url ? 'car-valuation' : 'default';
      }
    });
  }
}
